import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQualityInspectionList extends BaseModelAPI {

	static entity = 'finishgoodqualityinspectionlist'
	static entityName = 'finishgoodqualityinspection';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
